var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMicOffBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0 24 24 0 24z",
    transform: "translate(-424 -973) translate(24 230) translate(241 724) translate(159 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343A40",
    fillRule: "nonzero",
    d: "M11.758 2.182c-1.807 0-3.273 1.465-3.273 3.273v4.363c0 1.808 1.466 3.273 3.273 3.273 1.808 0 3.273-1.465 3.273-3.273V5.455c0-1.808-1.465-3.273-3.273-3.273zm0-2.182c1.447 0 2.834.575 3.857 1.598 1.023 1.023 1.598 2.41 1.598 3.857v4.363c0 3.013-2.442 5.455-5.455 5.455-3.012 0-5.454-2.442-5.454-5.455V5.455C6.304 2.442 8.746 0 11.758 0zM2 10.91h2.198c.547 3.753 3.765 6.538 7.56 6.538 3.793 0 7.012-2.785 7.558-6.539h2.2c-.512 4.558-4.109 8.156-8.667 8.667V24h-2.182v-4.424C6.11 19.066 2.511 15.468 2 10.91z",
    transform: "translate(-424 -973) translate(24 230) translate(241 724) translate(159 19)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#343A40",
    strokeWidth: 2,
    d: "M1 3L20 22",
    transform: "translate(-424 -973) translate(24 230) translate(241 724) translate(159 19)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicOffBlack);
export default __webpack_public_path__ + "static/media/ic-mic-off-black.e892f1d5.svg";
export { ForwardRef as ReactComponent };